import React from 'react';
import './Footer.css';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container footer__container">
        <div className="footer__content">
          <div className="footer__brand">
            <h3 className="footer__logo">営業・採用研修</h3>
            <p className="footer__tagline">
              経営者が意思決定・売上づくりに集中できる<br />
              実行型グロース支援
            </p>
          </div>

          <div className="footer__links">
            <div className="footer__section">
              <h4 className="footer__section-title">サービス</h4>
              <button onClick={() => scrollToSection('solution')} className="footer__link">
                採用支援
              </button>
              <button onClick={() => scrollToSection('solution')} className="footer__link">
                営業支援
              </button>
              <button onClick={() => scrollToSection('solution')} className="footer__link">
                育成・定着支援
              </button>
            </div>

            <div className="footer__section">
              <h4 className="footer__section-title">情報</h4>
              <button onClick={() => scrollToSection('results')} className="footer__link">
                実績
              </button>
              <button onClick={() => scrollToSection('why-us')} className="footer__link">
                選ばれる理由
              </button>
              <button onClick={() => scrollToSection('faq')} className="footer__link">
                よくある質問
              </button>
            </div>

            <div className="footer__section">
              <h4 className="footer__section-title">お問い合わせ</h4>
              <button onClick={() => scrollToSection('cta')} className="footer__link">
                無料相談
              </button>
              <button onClick={() => scrollToSection('profile')} className="footer__link">
                プロフィール
              </button>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">
            © 2024 営業・採用研修. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
